export const mainHeaderBG =
  "https://static.igem.wiki/teams/4380/wiki/main-header/main-header-background.svg"

export const mainHeaderTurtle =
  "https://static.igem.wiki/teams/4380/wiki/main-header/header-turtle-light.svg"

export const mainHeaderAttributions =
  "https://static.igem.wiki/teams/4380/wiki/main-header/attributions-photo.svg"

export const mainHeaderCollaboration =
  "https://static.igem.wiki/teams/4380/wiki/main-header/collaborations-header.svg"

export const mainHeaderContribution =
  "https://static.igem.wiki/teams/4380/wiki/main-header/contribution-turtle.svg"

export const mainHeaderDescription =
  "https://static.igem.wiki/teams/4380/wiki/description/description-turtle.svg"

export const mainHeaderModel =
  "https://static.igem.wiki/teams/4380/wiki/main-header/model-turtle.svg"
